export default {
  cardholder_name: 'Nome completo',
  cardholder_name_placeholder: 'Nome no cartão',
  card_number: 'Número do cartão',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Data de validade',
  expiry_placeholder: 'MM / AA',
  cvv: 'Código de segurança',
  cvv_label: 'Código de segurança (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'A inicializar o formulário seguro do cartão…',
  sdk_load_failed:
    'Não foi possível carregar o formulário seguro do cartão. Verifique a sua ligação e atualize a página.',
  errors: {
    number_blank: 'Introduza o número do seu cartão.',
    number_invalid: 'Este número de cartão não é válido. Verifique os dígitos e tente novamente.',
    number_incomplete: 'O número do seu cartão está incompleto.',
    cvv_blank: 'Introduza o código de segurança no verso do seu cartão.',
    cvv_invalid: 'Este código de segurança não é válido. Verifique os 3 ou 4 dígitos do seu cartão.',
    cvv_incomplete: 'Introduza os {{count}} dígitos do seu código de segurança.',
    expiry_invalid: 'Introduza uma data de validade válida no formato MM / AA.',
    expired: 'Este cartão expirou. Utilize outro cartão.',
    name_blank: 'Introduza o nome exatamente como aparece no seu cartão.',
    configuration: 'Os pagamentos por cartão não estão disponíveis neste momento. Tente outro método de pagamento.',
    generic: 'Não foi possível verificar os dados do seu cartão. Tente novamente.',
  },
};
